export const isMsBrowser = 'msSaveBlob' in window.navigator;
